import { types } from 'mobx-state-tree';

const Billing = types
  .model({
    category: types.string,
    isPaid: types.optional(types.boolean, false),
    endDate: types.maybeNull(types.Date),
    stripeInvoiceLink: types.maybeNull(types.string),
    stripePaymentMethodCountryCode: types.maybeNull(types.string),
    renewalType: types.maybeNull(types.string),
    billingPlanId: types.maybeNull(types.integer),
    renews: types.optional(types.boolean, true),
    startDate: types.maybeNull(types.Date),
  });

export default Billing;
